const DAY_MS = 24 * 60 * 60 * 1000;

const startOfDay = (value) => {
  const date = new Date(value);
  date.setHours(0, 0, 0, 0);
  return date.getTime();
};

export const getSessionDateGroupKey = (updatedAt, now = Date.now()) => {
  const ts = typeof updatedAt === "number" ? updatedAt : now;
  const diffDays = Math.floor((startOfDay(now) - startOfDay(ts)) / DAY_MS);

  if (diffDays <= 0) return "today";
  if (diffDays === 1) return "yesterday";
  if (diffDays <= 7) return "last_week";
  return "older";
};

export const SESSION_GROUP_LABEL_KEYS = {
  today: "cx_gpt.history_group_today",
  yesterday: "cx_gpt.history_group_yesterday",
  last_week: "cx_gpt.history_group_last_week",
  older: "cx_gpt.history_group_older",
};

const GROUP_ORDER = ["today", "yesterday", "last_week", "older"];

export const filterSessionsBySearch = (sessions, query) => {
  const sorted = [...sessions].sort(
    (a, b) => (b.updatedAt || 0) - (a.updatedAt || 0)
  );
  const q = (query || "").trim().toLowerCase();
  if (!q) return sorted;
  return sorted.filter((session) =>
    String(session.title || "")
      .toLowerCase()
      .includes(q)
  );
};

export const groupSessionsByDate = (sessions, now = Date.now()) => {
  const buckets = {};

  for (const session of sessions) {
    const key = getSessionDateGroupKey(session.updatedAt, now);
    if (!buckets[key]) buckets[key] = [];
    buckets[key].push(session);
  }

  return GROUP_ORDER.filter((key) => buckets[key]?.length).map((key) => ({
    key,
    labelKey: SESSION_GROUP_LABEL_KEYS[key],
    sessions: buckets[key].sort(
      (a, b) => (b.updatedAt || 0) - (a.updatedAt || 0)
    ),
  }));
};
